import { useDispatch, useSelector } from 'react-redux'
import { withStyles, makeStyles } from '@material-ui/core/styles'
import Drawer from '@material-ui/core/Drawer'
import ExitToAppIcon from '@material-ui/icons/ExitToApp'
import PersonIcon from '@material-ui/icons/Person'
import React from 'react'
import Typography from '@material-ui/core/Typography'
import { useLayoutContext } from '../LayoutContext'

import { clearCrendential } from 'src/features/Oauth/oauth.ducks'

import AppLink from './appLink'
import Header from './header'
import Menu from './menu'

const OAUTH_LINK = process.env.REACT_APP_OAUTH_ENDPOINT
const CLIENT_ID = process.env.REACT_APP_OAUTH_CLIENT_ID

const drawerWidth = 320
const SideDrawer = withStyles((theme) => ({
  drawer: { width: drawerWidth, flexShrink: 0 },
  drawerPaper: {
    width: drawerWidth,
    backgroundColor: theme.palette.secondary.dark,
    color: theme.palette.secondary.contrastText,
  },
}))(({ classes, children }) => {
  const { drawerOpen, switchDrawer } = useLayoutContext()

  return (
    <Drawer
      className={classes.drawer}
      classes={{ paper: classes.drawerPaper }}
      anchor="left"
      ////// responsive logics
      variant={!drawerOpen ? 'permanent' : 'temporary'}
      open={drawerOpen}
      onClose={switchDrawer}
    >
      {children}
    </Drawer>
  )
})

const useStyles = makeStyles((theme) => ({
  menu_container: { padding: '24px 16px' },
  title: { padding: theme.spacing(1), opacity: 0.8 },
}))

function Index() {
  const classes = useStyles()
  const dispatch = useDispatch()
  const access_token = useSelector((state) => state.oauth.access_token)

  const handleLogout = () => {
    dispatch(clearCrendential())
  }

  return (
    <SideDrawer>
      {/* header */}
      <Header />
      {/* menu */}
      <div className={classes.menu_container}>
        <div className={classes.title}>
          <Typography variant="caption">SHARMBLE ADMIN MALL</Typography>
        </div>
        {access_token !== null && <Menu />}
      </div>
      {/* log in */}
      {access_token === null ? (
        <AppLink icon={<PersonIcon />} href={`${OAUTH_LINK}/login?client_id=${CLIENT_ID}`} text="Login" />
      ) : (
        <AppLink href="#" clickHandle={handleLogout} icon={<ExitToAppIcon />} text="Logout" />
      )}
    </SideDrawer>
  )
}

export default Index
